function ClockIcon({ fill = '#4F4C4D', width = 21, height = 21 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7859 2.31641C6.18594 2.31641 2.46094 6.04974 2.46094 10.6497C2.46094 15.2497 6.18594 18.9831 10.7859 18.9831C15.3943 18.9831 19.1276 15.2497 19.1276 10.6497C19.1276 6.04974 15.3943 2.31641 10.7859 2.31641ZM10.7943 17.3164C7.11094 17.3164 4.1276 14.3331 4.1276 10.6497C4.1276 6.96641 7.11094 3.98307 10.7943 3.98307C14.4776 3.98307 17.4609 6.96641 17.4609 10.6497C17.4609 14.3331 14.4776 17.3164 10.7943 17.3164ZM9.96094 6.48307H11.2109V10.8581L14.9609 13.0831L14.3359 14.1081L9.96094 11.4831V6.48307Z"
        fill={fill}
      />
    </svg>
  );
}

export default ClockIcon;
